/* eslint-disable @intercom/intercom/no-bare-strings */
import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const collapsibleSectionSummarySpec = {
  defining: true,
  content: 'paragraph | heading | subheading | subheading3 | subheading4 | codeBlock',
  attrs: {
    type: {
      default: 'collapsibleSectionSummary'
    }
  },
  parseDOM: [{
    tag: 'summary'
  }],
  toDOM() {
    return ['summary', 0];
  }
};
export const collapsibleSectionContentSpec = {
  defining: true,
  content: '(block|list|table)+',
  attrs: {
    type: {
      default: 'collapsibleSectionContent'
    }
  },
  parseDOM: [{
    tag: `div.${BLOCK_CLASSES.collapsibleSectionContent}`
  }],
  toDOM() {
    return ['div', {
      class: BLOCK_CLASSES.collapsibleSectionContent
    }, 0];
  }
};
export const collapsibleSectionSpec = {
  inline: false,
  defining: true,
  content: 'collapsibleSectionSummary collapsibleSectionContent',
  group: 'block',
  attrs: {
    type: {
      default: 'collapsibleSection'
    },
    open: {
      default: true
    }
  },
  parseDOM: [{
    tag: 'details'
  }],
  toDOM(node) {
    let attrs = node.attrs.open ? {
      open: 'true'
    } : {};
    return ['details', attrs, 0];
  }
};